import React, { Component } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import { Container, Row, Col } from 'react-bootstrap';
import Kard from './Kard';
import Sertifikat from './Sertifikat';

export default class Pengalaman extends Component {

    state = { activeIndex: 0 }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    render() {
        const { activeIndex } = this.state

        return (
            <Container>
                <Row>
                    <Col>
                        <h3>Work</h3>
                        <Kard />
                    </Col>

                    <Col>
                        <h3>Volunteer</h3>
                        <Accordion fluid styled>
                            <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                                <Icon name='dropdown' />
                                Traumatic Healing KOGAMI Team
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 0}>
                                <p>
                                    After The Earthquake and recovery in the city of Padang, Indonesia, I joined KOGAMI (the Disaster and Tsunami Alert Community) conducted Traumatic Healing activities, for coastal children, especially in Playgroups and Elementary Schools in the red zone for 3 full months in the field
                                </p>
                            </Accordion.Content>
                            <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                                <Icon name='dropdown' />
                                Pramuka Peduli KWARDA Sumatera Barat
                            </Accordion.Title>
                            <Accordion.Content active={activeIndex === 1}>
                                <p>
                                    Become part of a special team from the Regional Scouting Institution to provide information on Knowledge about Disaster education
                                </p>
                            </Accordion.Content>
                        </Accordion>
                    </Col>
                    <Col>
                        <h3>Certificate</h3>
                        <Sertifikat />
                    </Col>

                </Row>
            </Container>
        )
    }
}